import { FlagDTO } from '@core/api/dtos/response/zone/flag'
import { Flag } from '@core/api/entities/zone/flag'

export class FlagMapper {
	static toEntity(dto: FlagDTO): Flag {
		return new Flag({
			id: dto.id,
			name: dto.name,
			key: dto.key,
		})
	}

	static toEntities(dtos: FlagDTO[]): Flag[] {
		return dtos.map((dto) => FlagMapper.toEntity(dto))
	}

	static toKeys(dtos: FlagDTO[]): string[] {
		return dtos
			.map((dto) => dto?.key)
			.filter((key): key is string => typeof key === 'string')
	}
}
